export default "__VITE_PUBLIC_ASSET__9c4715f2__"